var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeiboMobileLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m3.153 5.371.926.926-2.495 2.495c-.361.361-.39.934-.082 1.329l.083.095 1.039 1.038a1.01 1.01 0 0 0 1.424.001L6.542 8.76l.861.861-2.568 2.569a1.996 1.996 0 0 1-2.83 0l-1.42-1.42a2.005 2.005 0 0 1 0-2.83zm5.11-1.663.896.896-4.893 4.894L3.37 8.6zm2.504-3.12 1.42 1.42a2.005 2.005 0 0 1 0 2.831L9.688 7.335l-.861-.861 2.492-2.49c.362-.362.39-.935.083-1.33l-.084-.095-1.038-1.038a1.01 1.01 0 0 0-1.425-.001L6.365 4.01l-.926-.926L7.936.589a1.996 1.996 0 0 1 2.831 0"
})));
export default SvgWeiboMobileLink;